import $ from 'jquery';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TopPanel from './dashboard/TopPanel';
import EnginesTab from './dashboard/EnginesTab';
import BrowserView from './dashboard/BrowserView';
import Report from './dashboard/report/Report';
import { getUserInfo } from '../../api';

const styles = {
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh'
  },
  card: {
    margin: 10,
    textAlign: 'center'
  },
  progressBar: {
    margin: 'auto',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  }
};

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetails: null,
      userDetailsIntervalId: null,
      showReport: false,
      showPricing: false
    };
  }

  componentWillMount() {
    const { qtEngine, engine } = this.props;
    this.startInterval(engine, qtEngine);
  }

  componentWillUnmount() {
    const { userDetailsIntervalId } = this.state;

    clearInterval(userDetailsIntervalId);
  }

  _loadStripe = () => {
    $.ajax({
      url: 'https://js.stripe.com/v3/',
      dataType: 'script',
      success: () => console.log('Stripe loaded')
    });
  };

  sendChannelsToIFrame = channels => {
    const frame = document.getElementById('board_frame');
    if (!frame) return;
    frame.contentWindow.postMessage(
      JSON.stringify({ type: 'get_wss_channels', channels })
    );
  };

  onGetUserInfoSuccess = response => {
    // GETTING WSS CHANNELS TO SEND TO IFRAME

    const wssChannels = [];
    if (response.servers) {
      for (const [engine, params] of Object.entries(response.servers)) {
        wssChannels.push(params.channel);
      }
    }

    this.sendChannelsToIFrame(wssChannels);

    this.setState({
      userDetails: response
    });
  };

  restartInterval = engine => {
    const { userDetailsIntervalId } = this.state;
    clearInterval(userDetailsIntervalId);
    this.startInterval(engine);
  };

  startInterval = (engine, qtEngine) => {
    const { qtWindow } = this.props;

    const interval = setInterval(() => {
      getUserInfo(this.onGetUserInfoSuccess, engine, qtEngine);
    }, 3000);

    // GETTING STRIPE JS for Browser
    if (!qtWindow) {
      this._loadStripe();
    }

    this.setState({ userDetailsIntervalId: interval });
  };

  handleUsageInfo = () => {
    this.setState({ showReport: true });
  };

  goToPricingPage = () => {
    this.setState(state => ({
      showPricing: !state.showPricing
    }));
  };

  render() {
    const { classes, qtWindow, qtEngine, engine } = this.props;
    const { userDetails, showReport, showPricing } = this.state;

    if (!userDetails)
      return <CircularProgress className={classes.progressBar} />;

    let view = null;
    if (showReport) {
      view = (
        <Report
          isSuperuser={userDetails.is_superuser}
          backToMainPage={() => {
            this.setState({ showReport: false });
          }}
        />
      );
    } else if (!showPricing) {
      view = qtWindow ? (
        <EnginesTab
          user={userDetails}
          qtEngine={qtEngine}
          restartInterval={this.restartInterval}
        />
      ) : (
        <BrowserView user={userDetails} />
      );
    }
    return (
      <div className={classes.root}>
        <Grid container spacing={0} alignItems="center" style={{ margin: 5 }}>
          <Grid item xs={12}>
            <TopPanel
              user={userDetails}
              qtWindow={qtWindow}
              restartInterval={this.restartInterval}
              handleUsageInfo={this.handleUsageInfo}
              qtEngine={qtEngine}
              engine={engine}
              showReport={showReport}
              showPricing={showPricing}
              goToPricingPage={this.goToPricingPage}
            />
          </Grid>
          <Grid item xs={12} style={{ marginTop: 60 }}>
            {view}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(Dashboard);
